<template>
  <FiltersWrapper>
    <CollapseBlock class="filters" tablet-mode>
      <div class="filters__item">
        <CustomSelect
          :options="this.residents"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="this.filters.resident_id"
          @change="(value) => onFiltersChange('resident_id', value)"
        />
      </div>
      <div class="filters__item" style="width: 150px;">
        <CustomSelect
          :options="this.projectTypes"
          label="Тип проекта"
          optionValueKey="project_type_id"
          optionLabelKey="project_type_name"
          :value="this.filters.project_type_id"
          @change="(value) => onFiltersChange('project_type_id', value)"
        />
      </div>
      <div class="filters__item">
        <CustomSelect
          :options="this.entrances"
          label="Подъезд"
          optionValueKey="project_entrance_id"
          optionLabelKey="entrance_name"
          :loading="this.entrancesFetching"
          :value="this.filters.project_entrance_id"
          @change="(value) => onFiltersChange('project_entrance_id', value)"
        />
      </div>
    </CollapseBlock>
  </FiltersWrapper>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CollapseBlock from "@/components/common/CollapseBlock";
import FiltersWrapper from "@/components/common/FiltersWrapper";
import { getProjectTypes, getResidentialEntrances, getResidentList } from "../ResidentialSettings/services";

export default {
  name: "OpenSpaceLinksFilters",
  components: {CustomSelect, CollapseBlock, FiltersWrapper},
  props: ['getData', 'filters', 'onChange'],
  data() {
    return {
      residents: [],
      entrances: [],
      projectTypes: [],
    }
  },
  mounted() {
    this.getResidents()
  },
  methods: {
    async getResidents() {
      const res = await getResidentList()
      this.residents = res || []
    },
    async getProjectTypesData(resident_id) {
      const res = await getProjectTypes(resident_id)
      this.projectTypes = res || []
    },
    async getEntrances(filters) {
      this.entrancesFetching = true
      const res = await getResidentialEntrances(filters)
      this.entrancesFetching = false
      if(!res?.length) {
        this.entrances = []
        return
      }
      this.entrances = res
    },
    onFiltersChange(key, value) {
      const editedObject = {
        [key]: value,
      }

      if(key === 'resident_id') {
        editedObject.project_entrance_id = ''
        editedObject.project_type_id = ''
        if(!!value)
          this.getProjectTypesData(value)
        else {
          this.entrances = []
          this.projectTypes = []
        }
      }
      if(key === 'project_type_id') {
        editedObject.project_entrance_id = ''
        if(this.filters.resident_id) {
          if(!!value){
            this.getData({...this.filters, ...editedObject})
            this.getEntrances({...this.filters, ...editedObject})
          }
          else {
            this.entrances = []
          }
        }
      }
      if(key === 'project_entrance_id') {
        this.getData({...this.filters, ...editedObject})
      }
      this.onChange(editedObject)
    },
  }
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;

  &__item {
    min-width: 150px;
  }
}
</style>
